// import { configureStore } from '@reduxjs/toolkit';
// import themeSettingSlice from './themeSettingSlice';
// import sidebarSlice from './sidebarSlice';
// import  authSlice  from './authSlice';


// export const store = configureStore({
//   reducer: {
//     themeSetting: themeSettingSlice,
//     sidebarSlice: sidebarSlice,
//     authSlice:authSlice
//   },
// });

// // export default store;
// export const persistor = persistStore(store);

// import { configureStore } from '@reduxjs/toolkit'
// import  authSlice  from './authSlice'
// import themeSettingSlice from './themeSettingSlice';
// import sidebarSlice from './sidebarSlice';
// import storage from 'redux-persist/lib/storage';
// import { persistReducer, persistStore } from 'redux-persist';

// const persistConfig = {
//   key: 'root',
//   storage,
// }

// const authReducer = persistReducer(persistConfig, authSlice)



// export const store = configureStore({
//   reducer: {
//      auth: authReducer,
//      themeSetting:themeSettingSlice,
//      sidebarSlice:sidebarSlice,
//   },
// });
// // export type RootState = ReturnType<typeof store.getState>;
// // export type AppDispatch = typeof store.dispatch;

// export const persistor = persistStore(store);

import { configureStore } from '@reduxjs/toolkit'
import authSlice from './authSlice'
import themeSettingSlice from './themeSettingSlice';
import sidebarSlice from './sidebarSlice';
import storage from 'redux-persist/lib/storage';
import { persistReducer, persistStore, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';

const persistConfig = {
  key: 'root',
  storage,
}

const authReducer = persistReducer(persistConfig, authSlice)

export const store = configureStore({
  reducer: {
    auth: authReducer,
    themeSetting: themeSettingSlice,
    sidebarSlice: sidebarSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const persistor = persistStore(store);

